import script from "./EditDataStoreTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditDataStoreTable.vue?vue&type=script&setup=true&lang=ts"

import "./EditDataStoreTable.vue?vue&type=style&index=0&id=05152d8f&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05152d8f"]])

export default __exports__